import React from 'react';
import { AbortReason, Experiences } from '../../../../types';
import { useExperienceTracker } from '../../../utils/experience-tracking/adapter';
import { DocumentError, DocumentSkeleton } from '../../document';
import { ErrorBoundarySuspense } from '../../error-boundary-suspense';
var AsyncDocument = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_notification_body" */
  './main');
});
export default function Document(props) {
  var experienceTracker = useExperienceTracker();
  var handleDocumentChunkFail = function handleDocumentChunkFail() {
    experienceTracker.abort({
      name: Experiences.RENDER_NOTIFICATIONS_WITH_CONTENT,
      reason: AbortReason.CLIENT_ERROR
    });
  };
  return /*#__PURE__*/React.createElement(ErrorBoundarySuspense, {
    loadingFallback: /*#__PURE__*/React.createElement(DocumentSkeleton, null),
    errorFallback: /*#__PURE__*/React.createElement(DocumentError, null),
    onErrorCallback: handleDocumentChunkFail,
    subjectId: "document-chunk"
  }, /*#__PURE__*/React.createElement(AsyncDocument, props));
}